import {Link, withRouter} from 'react-router-dom';
import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import RedeemActions from '../../actions/RedeemActions';
import RedeemContainer from './RedeemContainer';
import SuccessStageStyled from './SuccessStageStyled';
import root from 'window-or-global';
import {generateRouteTo} from '../../utils/route';

class SuccessStage extends React.Component {
  static propTypes = {
    pcDownloadUrl: PropTypes.string,
    macDownloadUrl: PropTypes.string,
    iosDownloadUrl: PropTypes.string,
    androidDownloadUrl: PropTypes.string,
    supportedOS: PropTypes.array,
    location: PropTypes.object,
  };

  componentWillUnmount() {
    RedeemActions.resetFlow.defer();
  }

  isSupported = () => {
    const os = this.getOs();
    const supportedOS = this.props.supportedOS || ['windows'];
    return supportedOS.indexOf(os) >= 0;
  };

  getDownloadUrl = () => {
    let url = this.props.pcDownloadUrl || '#';
    const isSupported = this.isSupported();
    const os = this.getOs();
    if (isSupported) {
      switch (os) {
        case 'windows':
          url = this.props.pcDownloadUrl;
          break;
        case 'mac':
          url = this.props.macDownloadUrl;
          break;
        case 'ios':
          url = this.props.iosDownloadUrl;
          break;
        case 'android':
          url = this.props.androidDownloadUrl;
          break;
        default:
          url = this.props.pcDownloadUrl;
      }
    }

    return url;
  };

  getOs = () => {
    let os = 'windows';
    if (root._epicGamesNav.browser.mac) {
      os = 'mac';
    } else if (root._epicGamesNav.browser.linux) {
      os = 'linux';
    } else if (root._epicGamesNav.browser.ios) {
      os = 'ios';
    } else if (root._epicGamesNav.browser.android) {
      os = 'android';
    }
    return os;
  };

  render() {
    const inlineHomeButton = (
      <Link
        className="btn btn-default inline btn-fixed-width"
        to={generateRouteTo('/', this.props.location)}>
        <Message code="epic.common.back_to_home" />
      </Link>
    );
    const isSupported = this.isSupported();
    const os = this.getOs();
    const successClass = os === 'mobile' ? 'successMobile' : '';
    // Default
    const successMessageProps = {
      code: isSupported
        ? 'epic.code.redemption.success.msg'
        : 'epic.code.redemption.success.msg.other',
    };
    const downloadUrl = this.getDownloadUrl();

    // FN Crew (One Month Access) gets custom success message.
    const entitlementName =
      typeof this.props.redeemStore.entitlementName === 'string'
        ? this.props.redeemStore.entitlementName.toLowerCase()
        : '';
    if (entitlementName === 'fn_crew') {
      successMessageProps.code = 'epic.code.redemption.success.msg.fnCrew';
    }
    return (
      <SuccessStageStyled className="successStage">
        <RedeemContainer className="redeemContainer">
          <h1 className="site-block-page-title">
            <Message code="epic.code.redemption.success.title" />
          </h1>
          <div className="site-block">
            <div className={successClass}>
              <p>
                <Message {...successMessageProps} />
              </p>
              <div className="site-block-header">
                <h1 className="site-block-title">
                  <Message code="epic.code.redemption.success.subtitle" />
                </h1>
                <div className="clearfix" />
              </div>
              <div className="buttonContainer row">
                {isSupported ? (
                  <div className="col-sm-6">
                    <a className="btn btn-primary inline btn-fixed-width" href={downloadUrl}>
                      <Message code="epic.common.download" />
                    </a>
                  </div>
                ) : null}
                {os === 'linux' ? (
                  <div className="alternateDownload">
                    <a
                      className="btn btn-default inline btn-fixed-width"
                      href={this.props.pcDownloadUrl}>
                      <Message code="epic.code.redemption.success.download_windows" />
                    </a>
                  </div>
                ) : null}
                <div className="col-sm-6">{inlineHomeButton}</div>
              </div>
            </div>
          </div>
        </RedeemContainer>
      </SuccessStageStyled>
    );
  }
}

export default withRouter(SuccessStage);
